/**
 * React Query key factory for Support feature.
 * Provides consistent query keys for cache management and invalidation.
 */
export const supportQueryKeys = {
  all: ["support"] as const,

  eligibility: (workerId: string) => [...supportQueryKeys.all, "eligibility", workerId] as const,

  shifts: () => [...supportQueryKeys.all, "shifts"] as const,

  pastShifts: (workerId: string) => [...supportQueryKeys.shifts(), "past", workerId] as const,

  upcomingShifts: (workerId: string) =>
    [...supportQueryKeys.shifts(), "upcoming", workerId] as const,

  shiftDetails: (shiftId: string) => [...supportQueryKeys.shifts(), "details", shiftId] as const,

  scoreLedger: (workerId: string, shiftId?: string) =>
    [...supportQueryKeys.all, "scoreLedger", workerId, shiftId] as const,

  shiftPaymentStatus: (workerId: string, shiftId: string) =>
    [...supportQueryKeys.shifts(), "paymentStatus", workerId, shiftId] as const,
} as const;

export type SupportQueryKeys = typeof supportQueryKeys;
